import { Constants } from './constants';
import { appSettings } from '../environments/common/appsettingsGenerator';
import moment from 'moment';

export class RAvailUrlProvider {
  environmentConfig = appSettings();

  private requiredUrl = (name: string, value?: string): string => {
    if (!value) {
      throw new Error(`${name} is not configured for this environment.`);
    }
    return value;
  };

  public esxpBaseUrl = () => this.environmentConfig.esxpBaseUrl;

  public AvailabilityBaseUrl = () => this.environmentConfig.AvailabilityBaseUrl;

  public getDetailedCalendarUrl = () =>
    `${this.GrmApiBaseUrl()}/api/v1/Calendar/GetDetailedCalendar`;

  public GetTalentForecastUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.getTalentForecastUrl
    }`;

  public GetRecommenedForecastUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.getRecommendedAvlUrl
    }`;

  public GetCalendarEventsUrl = (startDate: Date, endDate: Date) =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.getCalendarEventsUrl
    }?startDate=${moment(startDate)
      .format()
      .replace(/[\+\-][0-9]+\:[0-9]+/i, '')}&endDate=${moment(endDate)
      .format()
      .replace(/[\+\-][0-9]+\:[0-9]+/i, '')}`;

  public GetCalendarSettingsUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.getCalendarSettingsUrl
    }`;

  public PostFreeFlexForecastUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.updateTalentForecastUrl
    }`;
  public GetForecastVarianceUrl = () =>
    `${this.AvailabilityBaseUrl()}${Constants.AvailabilityConstants.getForecastVariance}`;
  public GetAvailabilityConfigUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.fetchAvailabilityConfigUrl
    }`;

  public availabilityCreateNonProjectUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.createNonProjectDetailsEndUrl
    }`;

  /** GRM Calendar API: Create non-project request and schedules (direct, bypasses rmavl proxy) */
  public grmCreateNonProjectUrl = () =>
    `${this.GrmApiBaseUrl()}${Constants.GrmApiConstants.createNonProjectRequestAndSchedules}`;

  /** GRM Calendar API: Update non-project schedules by ID */
  public grmUpdateNonProjectUrl = (id: number | string) =>
    `${this.GrmApiBaseUrl()}${Constants.GrmApiConstants.updateNonProjectSchedules}${id}`;

  /** GRM Calendar API: Remove non-project schedules */
  public grmRemoveNonProjectUrl = () =>
    `${this.GrmApiBaseUrl()}${Constants.GrmApiConstants.removeNonProjectSchedules}`;

  public availabilityDeleteNonProjectUrl = (nprID: string) => {
    const url =
      Constants.AvailabilityConstants.deleteNonProjectDetailsEndUrl.replace(
        '{0}',
        nprID
      );
    return `${this.AvailabilityBaseUrl()}${url}`;
  };
  public PostCSAProjectAssignmentForecastUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.updateCSAProjectAssignmentForecastApi
    }`;

  public GetDSECapacityHoursUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.getDSECapacityHoursUrl
    }`;

  public AddUpdateDSECapacityHoursUrl = () =>
    `${this.AvailabilityBaseUrl()}${
      Constants.AvailabilityConstants.addUpdateDSECapacityHoursUrl
    }`;

  public GetDSEAssignmentSearchUrl = (): string => {
    return this.requiredUrl(
      'DSE assignment search',
      this.environmentConfig.SearchServiceUrl
    );
  };

  // ---- GRM ResourceManagement API (FM team calendar / approvals / add-event) ----
  public GrmApiBaseUrl = () =>
    this.requiredUrl('GRM API', this.environmentConfig.GrmApiBaseUrl);

  public GetTeamCalendarUrl = () =>
    `${this.GrmApiBaseUrl()}${Constants.GrmApiConstants.getTeamCalendarEndpoint}`;

  public GetDomainDataUrl = () =>
    `${this.GrmApiBaseUrl()}${Constants.GrmApiConstants.getDomainDataEndpoint}`;

  public GetMyPendingCalendarItemsUrl = () =>
    `${this.GrmApiBaseUrl()}${
      Constants.GrmApiConstants.getMyPendingCalendarItemsEndpoint
    }`;

  public GetDelegatedPendingCalendarItemsUrl = () =>
    `${this.GrmApiBaseUrl()}${
      Constants.GrmApiConstants.getDelegatedPendingCalendarItemsEndpoint
    }`;

  public ApproveRejectCalendarItemsUrl = () =>
    `${this.GrmApiBaseUrl()}${
      Constants.GrmApiConstants.approveRejectCalendarItemsEndpoint
    }`;

  public CreateNonProjectRequestUrl = () =>
    `${this.GrmApiBaseUrl()}${
      Constants.GrmApiConstants.createNonProjectRequestEndpoint
    }`;

  public GetEngagementDetailsForDSEUrl = () =>
    `${this.GrmApiBaseUrl()}${
      Constants.GrmApiConstants.engagementDetailsForDSEEndpoint
    }`;

  // ---- OneProfile OpGraphQL (profileskills) — FM profile/skill columns + manager search ----
  public OpGraphQlUrl = () =>
    this.requiredUrl(
      'OneProfile profileskills GraphQL',
      this.environmentConfig.OpGraphQlUrl
    );
}
